import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { Inscricao } from '../inscricao/inscricao';
import { InscricaoService } from '../inscricao/inscricao.service';
import { SituacaoEnum } from '../util/situacao.enum';

@Component({
  selector: 'inscricao-conclusao',
  templateUrl: './inscricao-conclusao.component.html',
  styleUrls: [ './inscricao-conclusao.component.css' ]
})
export class InscricaoConclusaoComponent implements OnInit {
    @Input() inscricao:Inscricao;
    @Input() sub:boolean = false;
    @Output() inscricaoOutput: EventEmitter<Inscricao> = new EventEmitter<Inscricao>();

    public isLoading: boolean;
    public podeConcluir: boolean;
    public mensagemTela: string;


    constructor(private route: ActivatedRoute,
      private inscricaoService: InscricaoService,
      private mensagem: MatSnackBar)  {
    }

    ngOnInit(){
      this.validaConclusao(this.inscricao);
    }

    validaConclusao(inscricao:Inscricao){
      if(this.inscricao.situacao == SituacaoEnum.NaoConcluido.id){
        this.podeConcluir = true;
      }else{
        this.mensagemInscricaoConcluida();
      }
    }

    concluir(){
      this.inscricao.situacao = SituacaoEnum.EmAnalise.id;
      this.isLoading = true;
      this.inscricaoService.update(this.inscricao).subscribe(result=> {
        this.inscricaoOutput.emit(result);
        this.isLoading = false;
        this.mensagemInscricaoConcluida();
        this.podeConcluir = false;
      },  error => this.erro(error));
    }

    mensagemInscricaoConcluida(){
      this.mensagemTela = "Sua inscrição foi concluída e será analisada. ";
    }

    // mostra erros na tela
   erro(erro: string){
       this.mensagem.open(erro, 'X', {duration: 5000});
       this.isLoading =false;
   }
}
